import React, { FunctionComponent, ReactNode, Fragment } from 'react';
import { TTypographyProps } from '@rbx/ui';
import SimpleLinkableTypeReference from './SimpleLinkableTypeReference';

export interface SimpleLinkableTypeReferenceListProps {
  types: string[];
  variant?: TTypographyProps['variant'];
  connector?: ReactNode;
  engineRevampEnabled?: boolean;
}

const SimpleLinkableTypeReferenceList: FunctionComponent<
  React.PropsWithChildren<SimpleLinkableTypeReferenceListProps>
> = ({ types, variant = 'code', connector = ', ', engineRevampEnabled = false }) => {
  return (
    <Fragment>
      {types.map((type, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <SimpleLinkableTypeReference
            type={type}
            variant={variant}
            engineRevampEnabled={engineRevampEnabled}
          />
          {index !== types.length - 1 && connector}
        </Fragment>
      ))}
    </Fragment>
  );
};

export default SimpleLinkableTypeReferenceList;
